<template>
	<div class="rowHead">
		<div class="rowHead-title">Ряд {{ number }}</div>
		<input class="rowHead-input" type="text" min="1" v-model="count">
		<button class="rowHead-button" @click.prevent="$emit('copy', +count)">Создать копий</button>
		<a href="#" class="rowHead-remove" @click.prevent="$emit('remove')" title="Удалить"></a>
	</div>
</template>

<script>
	export default {
		name: 'RowHead',
		props: {
			number: Number,
		},
		data() {
			return {
				count: 1,
			};
		},
	}
</script>

<style>
	.rowHead {
		display: flex;
		align-items: center;
		padding: 13px;
		padding-left: 24px;
		background: #F6F6F6;
	}
	.rowHead-title {
		font-family: Oswald, Roboto, sans-serif;
		font-size: 14px;
		font-weight: 500;
		text-decoration: none;
		text-transform: uppercase;
		line-height: 24px;
		color: #0B53B3;
	}
	.rowHead-input {
		margin: -4px 16px;
		padding: 4px 0;
		width: 48px;
		font-size: 16px;
		text-align: center;
		background: white;
		border: 1px solid #CECECE;
		outline: none;
	}
	.rowHead .rowHead-button {
		padding: 5px 16px;
		width: auto;
		font-size: 14px;
		background: #0B53B3;
	}
	.rowHead-copy {
		display: inline-block;
		margin-left: 12px;
		width: 24px;
		height: 24px;
		background: url(../../public/icons/copy.svg) no-repeat center center;
	}
	.rowHead-remove {
		display: inline-block;
		margin-left: auto;
		width: 24px;
		height: 24px;
		background: url(../../public/icons/cross_blue.svg) no-repeat center center;
	}
</style>
